import './require-shim';
// React-Core
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Redux
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import callAPIMiddleware from './middleware/callAPIMiddleware';
import reducer from './reducers';

import App from './App';

// SCSS
import './assets/scss/contentStyles.scss';
import './assets/scss/layoutStyles.scss';
import 'toastr/build/toastr.min.css';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 5000,
    },
  },
});

const middleware = [thunkMiddleware, callAPIMiddleware];

if (import.meta.env.MODE !== 'production') {
  middleware.push(createLogger());
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Unable to find the application root element.');
}

createRoot(rootElement).render(
  <Provider store={createStore(reducer, applyMiddleware(...middleware))}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
);

// eslint-disable-next-line import/prefer-default-export
export { queryClient };
